// extracted by mini-css-extract-plugin
module.exports = {"search":"styles-module--search--13QB4","input":"styles-module--input--OKlgT","button":"styles-module--button--2rw5k"};